export default __webpack_public_path__ + "static/media/BDSBanner.bb197f93.jpg";